import { AppConfig } from '@ltvco/refresh-lib/ctx';
import { useQuery } from '@ltvco/refresh-lib/vendors';
import { useContext } from 'react';

import { usdaRecalls } from '../api';

import { USDA_RECALLS_QUERY_KEY_PREFIX } from './constants';

import type { UsdaRecallParams, UsdaRecallRecord } from '../interfaces';

export const useUsdaRecalls = (
  params?: UsdaRecallParams | null,
  options?: { enabled?: boolean }
) => {
  const { logError } = useContext(AppConfig);
  const enabled = options?.enabled !== false;

  return useQuery<UsdaRecallRecord[]>(
    [USDA_RECALLS_QUERY_KEY_PREFIX, params ?? null],
    () => usdaRecalls.fetchRecalls(params ?? undefined),
    {
      enabled,
      refetchOnWindowFocus: false,
      onError: (error: unknown) => {
        logError(`${USDA_RECALLS_QUERY_KEY_PREFIX} failed`, error as Error);
      },
    }
  );
};
